// extracted by mini-css-extract-plugin
export default {"wrapper":"w7jfF","user-wrapper":"zAlkc","user-name":"vYsZl","dropdown":"arsC0","button-wrapper":"qECxy","button":"YSU6P","icon":"CKPsn"};